var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-facets-footer-section.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
env.getTemplate("macros/urls.j2", false, "category/templates/facets/category-facets-footer-section.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
output += "\n\n";
if(((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"totalSelectedFacets") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSortSelected")) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"queryString"))) {
output += "\n    ";
var t_5;
t_5 = "";
frame.set("resetClass", t_5, true);
if(frame.topLevel) {
context.setVariable("resetClass", t_5);
}
if(frame.topLevel) {
context.addExport("resetClass", t_5);
}
output += "\n    ";
var t_6;
t_6 = "";
frame.set("ariaLabel", t_6, true);
if(frame.topLevel) {
context.setVariable("ariaLabel", t_6);
}
if(frame.topLevel) {
context.addExport("ariaLabel", t_6);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_7;
t_7 = "c-facets-container__footer-clear-button--disabled";
frame.set("resetClass", t_7, true);
if(frame.topLevel) {
context.setVariable("resetClass", t_7);
}
if(frame.topLevel) {
context.addExport("resetClass", t_7);
}
output += "\n    ";
var t_8;
t_8 = (lineno = 9, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_aria-reset-facets-disabled"]));
frame.set("ariaLabel", t_8, true);
if(frame.topLevel) {
context.setVariable("ariaLabel", t_8);
}
if(frame.topLevel) {
context.addExport("ariaLabel", t_8);
}
output += "\n";
;
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "singleFacetCount") && runtime.contextOrFrameLookup(context, frame, "singleFacetCount") > 0) {
output += "\n    ";
var t_9;
t_9 = "";
frame.set("singleFacetResetClass", t_9, true);
if(frame.topLevel) {
context.setVariable("singleFacetResetClass", t_9);
}
if(frame.topLevel) {
context.addExport("singleFacetResetClass", t_9);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_10;
t_10 = "c-facets-container__footer-clear-button--disabled";
frame.set("singleFacetResetClass", t_10, true);
if(frame.topLevel) {
context.setVariable("singleFacetResetClass", t_10);
}
if(frame.topLevel) {
context.addExport("singleFacetResetClass", t_10);
}
output += "\n";
;
}
output += "\n\n";
if((lineno = 18, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["navItem.name"])) == (lineno = 18, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.categoryRefinementNames.PRICE"]))) {
output += "\n    ";
var t_11;
t_11 = "js-price-button";
frame.set("priceJsClass", t_11, true);
if(frame.topLevel) {
context.setVariable("priceJsClass", t_11);
}
if(frame.topLevel) {
context.addExport("priceJsClass", t_11);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_12;
t_12 = "";
frame.set("priceJsClass", t_12, true);
if(frame.topLevel) {
context.setVariable("priceJsClass", t_12);
}
if(frame.topLevel) {
context.addExport("priceJsClass", t_12);
}
output += "\n";
;
}
output += "\n\n<div class=\"c-facets-container__footer-section\">\n    <div class=\"g-facets-container-footer__outer\">\n    \t<div class=\"g-facets-container-footer__button-container g-facets-container-footer__button-container--left\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "singleFacetType")) {
output += "\n                <a class=\"c-facets-container__footer-clear-button ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "singleFacetResetClass"), env.opts.autoescape);
output += " js-mobile-filter-clear ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "priceJsClass"), env.opts.autoescape);
output += "\" href=\"#\" data-applied-facets-query=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"refinements")),0)),"queryString")), env.opts.autoescape);
output += "\" data-facet-type=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"refinements")),0)),"name"), env.opts.autoescape);
output += "\" data-qa-reset-facet-link=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
output += "\">\n                    <span class=\"c-facets-container__footer-clear-text\">";
output += runtime.suppressValue((lineno = 29, colno = 74, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-clear-label"])), env.opts.autoescape);
output += "</span>\n                </a>\n            ";
;
}
else {
output += "\n                <a class=\"c-facets-container__footer-clear-button ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "resetClass"), env.opts.autoescape);
output += " js-facets-reset ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "priceJsClass"), env.opts.autoescape);
output += "\" data-facets-reset=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"facetOptions")),"reset")),"queryString")), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 32, colno = 197, runtime.callWrap(t_4, "genericUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"catalogRequestPathname"),runtime.makeKeywordArgs({"excludeContextPath": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\" aria-label=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ariaLabel"), env.opts.autoescape);
output += "\" data-qa-reset-all-link>\n                    <span class=\"c-facets-container__footer-clear-text\">";
output += runtime.suppressValue((lineno = 33, colno = 74, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-clear-label"])), env.opts.autoescape);
output += "</span>\n                </a>\n            ";
;
}
output += "\n\t\t</div>\n\n\t\t<div class=\"g-facets-container-footer__button-container g-facets-container-footer__button-container--right\">\n\t\t    <a class=\"c-facets-container__footer-done-button js-mobile-filter-close ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "priceJsClass"), env.opts.autoescape);
output += "\" href=\"#\" data-qa-mobile-done-button>\n\t\t        ";
output += runtime.suppressValue((lineno = 40, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-close-label"])), env.opts.autoescape);
output += "\n\t\t    </a>\n\t\t</div>\n\t</div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-facets-footer-section.j2"] , dependencies)